module.exports = __webpack_public_path__ + "static/media/guest_icon_color.0281de99.png";